import React from 'react';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { cells, grid } from '../../../styling/utils/grid';

interface SkeletonProps {
  $cells: number;
}

const StyledSkeletonWrapper = styled.li<SkeletonProps>`
  ${grid}
  ${(p) => cells(p.$cells)}
  padding: 1.2rem 0.8rem;
  gap: 1.6rem;
  border-bottom: 1px solid ${getColor('grey', 300)};

  &:nth-child(even) {
    background-color: ${getColor('grey', 100)};
  }

  &:last-child {
    border-bottom: none;
  }

  .skeleton__text {
    max-width: 100px;
  }
`;

const SkeletonListItemDesktop = ({ items, cells, loading }) => {
  return (
    <>
      {loading &&
        [...Array(items)].map((e, index) => (
          <StyledSkeletonWrapper
            className="skeleton"
            key={index}
            $cells={cells}
          >
            {[...Array(cells - 1)].map((e, index) => (
              <span className="skeleton skeleton__text" key={index}>
                &nbsp;
              </span>
            ))}
          </StyledSkeletonWrapper>
        ))}
    </>
  );
};

export default SkeletonListItemDesktop;
